<template lang="pug">
  tbody
    tr
      th(colspan=2) {{ lottery_1d_title }}
      td.text-center {{ lottery_1d_upline_pt }}%
      td.text-center(v-show="isSearch") {{ lottery_1d_account_pt }}%
      td.text-center(v-show="isSearch") {{ lottery_1d_upline_remaining}}%
      td.text-center(v-show="isSearch") {{ lottery_1d_account_min }}%
    tr
      th(colspan=2) {{ lottery_2d_title }}
      td.text-center {{ lottery_2d_upline_pt }}%
      td.text-center(v-show="isSearch") {{ lottery_2d_account_pt }}%
      td.text-center(v-show="isSearch") {{ lottery_2d_upline_remaining}}%
      td.text-center(v-show="isSearch") {{ lottery_2d_account_min }}%
</template>

<script>
export default {
  props: {
    isSearch: false
  },
  data() {
    return {
      lottery_1d_upline_min: 0,
      lottery_1d_upline_max: 0,
      lottery_1d_upline_pt: 0,
      lottery_1d_account_pt: 0,
      lottery_1d_upline_remaining: 0,
      lottery_1d_account_min: 0,
      lottery_2d_upline_min: 0,
      lottery_2d_upline_max: 0,
      lottery_2d_upline_pt: 0,
      lottery_2d_account_pt: 0,
      lottery_2d_upline_remaining: 0,
      lottery_2d_account_min: 0
    }
  },
  computed: {
    lottery_1d_title: function () {
      return this.$t("ui.lottery_1d") + " (" + this.lottery_1d_upline_min + "%-" + this.lottery_1d_upline_max + "%)"
    },
    lottery_2d_title: function () {
      return this.$t("ui.lottery_2d") + " (" + this.lottery_2d_upline_min + "%-" + this.lottery_2d_upline_max + "%)"
    }
  }
}

</script>